function cov_1bf3wwzwf() {
  var path = "/app/src/components/icon/icon.tsx";
  var hash = "5ffae3aa8e5bb16fe28dd63adf605e59ebcc5670";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/icon/icon.tsx",
    statementMap: {
      "0": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 64,
          column: 1
        }
      },
      "1": {
        start: {
          line: 47,
          column: 19
        },
        end: {
          line: 47,
          column: 42
        }
      },
      "2": {
        start: {
          line: 48,
          column: 18
        },
        end: {
          line: 48,
          column: 40
        }
      },
      "3": {
        start: {
          line: 49,
          column: 27
        },
        end: {
          line: 49,
          column: 55
        }
      },
      "4": {
        start: {
          line: 50,
          column: 22
        },
        end: {
          line: 50,
          column: 48
        }
      },
      "5": {
        start: {
          line: 51,
          column: 31
        },
        end: {
          line: 51,
          column: 63
        }
      },
      "6": {
        start: {
          line: 52,
          column: 26
        },
        end: {
          line: 52,
          column: 56
        }
      },
      "7": {
        start: {
          line: 53,
          column: 21
        },
        end: {
          line: 53,
          column: 46
        }
      },
      "8": {
        start: {
          line: 54,
          column: 22
        },
        end: {
          line: 54,
          column: 47
        }
      },
      "9": {
        start: {
          line: 55,
          column: 20
        },
        end: {
          line: 55,
          column: 40
        }
      },
      "10": {
        start: {
          line: 56,
          column: 21
        },
        end: {
          line: 56,
          column: 42
        }
      },
      "11": {
        start: {
          line: 57,
          column: 19
        },
        end: {
          line: 57,
          column: 38
        }
      },
      "12": {
        start: {
          line: 58,
          column: 19
        },
        end: {
          line: 58,
          column: 38
        }
      },
      "13": {
        start: {
          line: 59,
          column: 25
        },
        end: {
          line: 59,
          column: 50
        }
      },
      "14": {
        start: {
          line: 60,
          column: 24
        },
        end: {
          line: 60,
          column: 48
        }
      },
      "15": {
        start: {
          line: 61,
          column: 24
        },
        end: {
          line: 61,
          column: 48
        }
      },
      "16": {
        start: {
          line: 62,
          column: 19
        },
        end: {
          line: 62,
          column: 42
        }
      },
      "17": {
        start: {
          line: 63,
          column: 20
        },
        end: {
          line: 63,
          column: 44
        }
      },
      "18": {
        start: {
          line: 67,
          column: 2
        },
        end: {
          line: 67,
          column: 36
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 47,
            column: 9
          }
        },
        loc: {
          start: {
            line: 47,
            column: 19
          },
          end: {
            line: 47,
            column: 42
          }
        },
        line: 47
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 48,
            column: 7
          },
          end: {
            line: 48,
            column: 8
          }
        },
        loc: {
          start: {
            line: 48,
            column: 18
          },
          end: {
            line: 48,
            column: 40
          }
        },
        line: 48
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 49,
            column: 16
          },
          end: {
            line: 49,
            column: 17
          }
        },
        loc: {
          start: {
            line: 49,
            column: 27
          },
          end: {
            line: 49,
            column: 55
          }
        },
        line: 49
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 50,
            column: 11
          },
          end: {
            line: 50,
            column: 12
          }
        },
        loc: {
          start: {
            line: 50,
            column: 22
          },
          end: {
            line: 50,
            column: 48
          }
        },
        line: 50
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 51,
            column: 20
          },
          end: {
            line: 51,
            column: 21
          }
        },
        loc: {
          start: {
            line: 51,
            column: 31
          },
          end: {
            line: 51,
            column: 63
          }
        },
        line: 51
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 52,
            column: 15
          },
          end: {
            line: 52,
            column: 16
          }
        },
        loc: {
          start: {
            line: 52,
            column: 26
          },
          end: {
            line: 52,
            column: 56
          }
        },
        line: 52
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 53,
            column: 10
          },
          end: {
            line: 53,
            column: 11
          }
        },
        loc: {
          start: {
            line: 53,
            column: 21
          },
          end: {
            line: 53,
            column: 46
          }
        },
        line: 53
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 54,
            column: 11
          },
          end: {
            line: 54,
            column: 12
          }
        },
        loc: {
          start: {
            line: 54,
            column: 22
          },
          end: {
            line: 54,
            column: 47
          }
        },
        line: 54
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 55,
            column: 9
          },
          end: {
            line: 55,
            column: 10
          }
        },
        loc: {
          start: {
            line: 55,
            column: 20
          },
          end: {
            line: 55,
            column: 40
          }
        },
        line: 55
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 56,
            column: 10
          },
          end: {
            line: 56,
            column: 11
          }
        },
        loc: {
          start: {
            line: 56,
            column: 21
          },
          end: {
            line: 56,
            column: 42
          }
        },
        line: 56
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 57,
            column: 9
          }
        },
        loc: {
          start: {
            line: 57,
            column: 19
          },
          end: {
            line: 57,
            column: 38
          }
        },
        line: 57
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        },
        loc: {
          start: {
            line: 58,
            column: 19
          },
          end: {
            line: 58,
            column: 38
          }
        },
        line: 58
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 59,
            column: 14
          },
          end: {
            line: 59,
            column: 15
          }
        },
        loc: {
          start: {
            line: 59,
            column: 25
          },
          end: {
            line: 59,
            column: 50
          }
        },
        line: 59
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 60,
            column: 13
          },
          end: {
            line: 60,
            column: 14
          }
        },
        loc: {
          start: {
            line: 60,
            column: 24
          },
          end: {
            line: 60,
            column: 48
          }
        },
        line: 60
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 61,
            column: 13
          },
          end: {
            line: 61,
            column: 14
          }
        },
        loc: {
          start: {
            line: 61,
            column: 24
          },
          end: {
            line: 61,
            column: 48
          }
        },
        line: 61
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 62,
            column: 8
          },
          end: {
            line: 62,
            column: 9
          }
        },
        loc: {
          start: {
            line: 62,
            column: 19
          },
          end: {
            line: 62,
            column: 42
          }
        },
        line: 62
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 63,
            column: 9
          },
          end: {
            line: 63,
            column: 10
          }
        },
        loc: {
          start: {
            line: 63,
            column: 20
          },
          end: {
            line: 63,
            column: 44
          }
        },
        line: 63
      },
      "17": {
        name: "Icon",
        decl: {
          start: {
            line: 66,
            column: 16
          },
          end: {
            line: 66,
            column: 20
          }
        },
        loc: {
          start: {
            line: 66,
            column: 57
          },
          end: {
            line: 68,
            column: 1
          }
        },
        line: 66
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5ffae3aa8e5bb16fe28dd63adf605e59ebcc5670"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1bf3wwzwf = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1bf3wwzwf();
import React from 'react';
import { ReactComponent as ArrowIcon } from './assets/arrow.svg';
import { ReactComponent as Asterisks } from './assets/asterisks.svg';
import { ReactComponent as BagIcon } from './assets/bag.svg';
import { ReactComponent as Card } from './assets/card.svg';
import { ReactComponent as DealIcon } from './assets/deal.svg';
import { ReactComponent as Dirham } from './assets/dirham.svg';
import { ReactComponent as InfoIcon } from './assets/info.svg';
import { ReactComponent as Lightning } from './assets/lightning.svg';
import { ReactComponent as Moon } from './assets/moon.svg';
import { ReactComponent as PeopleIcon } from './assets/people.svg';
import { ReactComponent as PercentagesIcon } from './assets/percentages.svg';
import { ReactComponent as Protection } from './assets/protection.svg';
import { ReactComponent as RamdanIcon } from './assets/ramadan.svg';
import { ReactComponent as Riyal } from './assets/riyal.svg';
import { ReactComponent as ShariatIcon } from './assets/shariat.svg';
import { ReactComponent as ShariatModernIcon } from './assets/shariat-modern.svg';
import { ReactComponent as TabbyCareIcon } from './assets/tabby-care.svg';
var ICONS = (cov_1bf3wwzwf().s[0]++, {
  info: function info(props) {
    cov_1bf3wwzwf().f[0]++;
    cov_1bf3wwzwf().s[1]++;
    return /*#__PURE__*/React.createElement(InfoIcon, props);
  },
  bag: function bag(props) {
    cov_1bf3wwzwf().f[1]++;
    cov_1bf3wwzwf().s[2]++;
    return /*#__PURE__*/React.createElement(BagIcon, props);
  },
  'tabby-care': function tabbyCare(props) {
    cov_1bf3wwzwf().f[2]++;
    cov_1bf3wwzwf().s[3]++;
    return /*#__PURE__*/React.createElement(TabbyCareIcon, props);
  },
  shariat: function shariat(props) {
    cov_1bf3wwzwf().f[3]++;
    cov_1bf3wwzwf().s[4]++;
    return /*#__PURE__*/React.createElement(ShariatIcon, props);
  },
  'shariat-modern': function shariatModern(props) {
    cov_1bf3wwzwf().f[4]++;
    cov_1bf3wwzwf().s[5]++;
    return /*#__PURE__*/React.createElement(ShariatModernIcon, props);
  },
  percentages: function percentages(props) {
    cov_1bf3wwzwf().f[5]++;
    cov_1bf3wwzwf().s[6]++;
    return /*#__PURE__*/React.createElement(PercentagesIcon, props);
  },
  people: function people(props) {
    cov_1bf3wwzwf().f[6]++;
    cov_1bf3wwzwf().s[7]++;
    return /*#__PURE__*/React.createElement(PeopleIcon, props);
  },
  ramadan: function ramadan(props) {
    cov_1bf3wwzwf().f[7]++;
    cov_1bf3wwzwf().s[8]++;
    return /*#__PURE__*/React.createElement(RamdanIcon, props);
  },
  riyal: function riyal(props) {
    cov_1bf3wwzwf().f[8]++;
    cov_1bf3wwzwf().s[9]++;
    return /*#__PURE__*/React.createElement(Riyal, props);
  },
  dirham: function dirham(props) {
    cov_1bf3wwzwf().f[9]++;
    cov_1bf3wwzwf().s[10]++;
    return /*#__PURE__*/React.createElement(Dirham, props);
  },
  card: function card(props) {
    cov_1bf3wwzwf().f[10]++;
    cov_1bf3wwzwf().s[11]++;
    return /*#__PURE__*/React.createElement(Card, props);
  },
  moon: function moon(props) {
    cov_1bf3wwzwf().f[11]++;
    cov_1bf3wwzwf().s[12]++;
    return /*#__PURE__*/React.createElement(Moon, props);
  },
  protection: function protection(props) {
    cov_1bf3wwzwf().f[12]++;
    cov_1bf3wwzwf().s[13]++;
    return /*#__PURE__*/React.createElement(Protection, props);
  },
  lightning: function lightning(props) {
    cov_1bf3wwzwf().f[13]++;
    cov_1bf3wwzwf().s[14]++;
    return /*#__PURE__*/React.createElement(Lightning, props);
  },
  asterisks: function asterisks(props) {
    cov_1bf3wwzwf().f[14]++;
    cov_1bf3wwzwf().s[15]++;
    return /*#__PURE__*/React.createElement(Asterisks, props);
  },
  deal: function deal(props) {
    cov_1bf3wwzwf().f[15]++;
    cov_1bf3wwzwf().s[16]++;
    return /*#__PURE__*/React.createElement(DealIcon, props);
  },
  arrow: function arrow(props) {
    cov_1bf3wwzwf().f[16]++;
    cov_1bf3wwzwf().s[17]++;
    return /*#__PURE__*/React.createElement(ArrowIcon, props);
  }
});
export function Icon(_ref) {
  var icon = _ref.icon,
    svgAttributes = _ref.svgAttributes;
  cov_1bf3wwzwf().f[17]++;
  cov_1bf3wwzwf().s[18]++;
  return ICONS[icon](svgAttributes);
}